/**
 * UITypes
 * @module ui
 * @namespace core
 * @since 1.0.0
 * @note default (and overridable) base ui components of ui-predicate (e.g. target select, operator select, add button, remove button, ...)
*/
module.exports = {
    TARGETS: 'TARGETS',
    LOGICAL_TYPES: 'LOGICAL_TYPES',
    OPERATORS: 'OPERATORS',
    PREDICATE_ADD: 'PREDICATE_ADD',
    PREDICATE_REMOVE: 'PREDICATE_REMOVE',
    ARGUMENT_DEFAULT: 'ARGUMENT_DEFAULT',
}
